import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Text, Inline, Badge } from "braid-design-system";
import clsx from "clsx";
import { useEmployerHeaderContext } from "../../EmployerHeader.mjs";
import { translations } from "../../../../EmployerHeader/components/Navigation/.vocab/index.mjs";
import { headerLink, navItem, touchableNavItem, desktopNavItem, nestedMobileNavItem } from "./Navigation.css.mjs";
const handleClick = (props, analyticsEvent, handleInteractionTracking) => (event) => {
  if (analyticsEvent) {
    handleInteractionTracking(analyticsEvent);
  }
  if (props.onClick) {
    props.onClick(event);
  }
};
const CustomHeaderDesktopLink = ({
  active = false,
  activeStyle,
  linkRenderer: LinkRenderer,
  analyticsEvent,
  children,
  ...props
}) => {
  const headerItemLinkClasses = [
    headerLink,
    navItem,
    touchableNavItem,
    desktopNavItem,
    active ? activeStyle : ""
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = { ...props, className: clsx(headerItemLinkClasses) };
  return /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, analyticsEvent, handleInteractionTracking),
      children: /* @__PURE__ */ jsx(Text, { size: "small", children })
    }
  );
};
const CustomDesktopSubItemHeaderLink = ({
  children,
  active,
  activeStyle,
  linkRenderer: LinkRenderer,
  analyticsEvent,
  isBeta,
  ...props
}) => {
  const { t } = useTranslations(translations);
  const sharedHeaderSubItemLinkClasses = [
    headerLink,
    navItem,
    touchableNavItem,
    desktopNavItem,
    active ? activeStyle : ""
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = {
    ...props,
    className: clsx(sharedHeaderSubItemLinkClasses)
  };
  return /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, analyticsEvent, handleInteractionTracking),
      children: /* @__PURE__ */ jsxs(Inline, { space: "xsmall", children: [
        /* @__PURE__ */ jsx(Text, { size: "small", children }),
        isBeta && /* @__PURE__ */ jsx(Badge, { tone: "promote", bleedY: true, children: t("Beta") })
      ] })
    }
  );
};
const CustomDesktopDropdownLink = ({
  linkRenderer: LinkRenderer,
  analyticsEvent,
  children,
  ...props
}) => {
  const desktopDropdownLinkClasses = [
    headerLink,
    navItem
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = {
    ...props,
    className: clsx(desktopDropdownLinkClasses)
  };
  return /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, analyticsEvent, handleInteractionTracking),
      children: /* @__PURE__ */ jsx(Text, { size: "small", children })
    }
  );
};
const CustomHeaderMobileLink = ({
  active = false,
  activeStyle,
  linkRenderer: LinkRenderer,
  isNested = false,
  analyticsEvent,
  isBeta,
  children,
  ...props
}) => {
  const headerItemLinkClasses = [
    headerLink,
    navItem,
    touchableNavItem,
    isNested ? nestedMobileNavItem : ""
  ];
  const { t } = useTranslations(translations);
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = {
    ...props,
    className: clsx(headerItemLinkClasses)
  };
  return /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(props, analyticsEvent, handleInteractionTracking),
      children: /* @__PURE__ */ jsxs(Inline, { space: "xsmall", children: [
        /* @__PURE__ */ jsx(Text, { weight: active ? "strong" : "regular", children }),
        isBeta && /* @__PURE__ */ jsx(Badge, { tone: "promote", bleedY: true, children: t("Beta") })
      ] })
    }
  );
};
export {
  CustomDesktopDropdownLink,
  CustomDesktopSubItemHeaderLink,
  CustomHeaderDesktopLink,
  CustomHeaderMobileLink
};
